import React, { useState } from "react";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Main from "../layout/Main";
import { makeStyles } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  "@global": {
    "*": {
      boxSizing: "border-box",
      padding: 0,
      margin: 0,
    },
  },
  appLayout: {
    minHeight: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));

const light = createMuiTheme({
  palette: {
    primary: {
      light: "#7986cb",
      main: "#3f51b5",
      dark: "#303f9f",
      contrastText: "#ffffff",
      shadow: "#7986cb",
    },
    secondary: {
      main: "#3f51b5",
    },
    text: {
      primary: "rgba(0, 0, 0, 0.87)",
      secondary: "rgba(0, 0, 0, 0.65)",
      disabled: "rgba(0, 0, 0, 0.38)",
      hint: "rgba(0, 0, 0, 0.38)",
      divider: "rgba(0, 0, 0, 0.12)",
    },
    background: {
      paper: "#fafafa",
      default: "#e0e0e0",
      contrast: "#cccccc",
    },
  },
});

// const light = createMuiTheme({
//   palette: {
//     primary: {
//       light: "#007cba",
//       main: "#006ba1",
//       dark: "#005a87",
//       contrastText: "#ffffff",
//       shadow: "#007cba",
//     },

//     text: {
//       primary: "rgba(0, 0, 0, 0.87)",
//       secondary: "rgba(0, 0, 0, 0.54)",
//       disabled: "rgba(0, 0, 0, 0.38)",
//       hint: "rgba(0, 0, 0, 0.38)",
//       divider: "rgba(0, 0, 0, 0.12)",
//     },
//     background: {
//       paper: "#fafafa",
//       default: "#e0e0e0",
//     },
//   },
// });

const dark = createMuiTheme({
  palette: {
    primary: {
      light: "#424242",
      main: "#212121",
      dark: "#000000",
      contrastText: "#aaaaaa",
      shadow: "#000000",
    },
    secondary: {
      main: "#fafafa",
    },
    text: {
      primary: "#ffffff",
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      hint: "rgba(255, 255, 255, 0.5)",
      divider: "rgba(255, 255, 255, 0.12)",
    },
    background: {
      paper: "#212121",
      default: "#000000",
      contrast: "#333333",
    },
  },
});

const Layout = ({ children }) => {
  const classes = useStyles();
  const [darkMode, setDarkMode] = useState(false);
  const theme = darkMode ? dark : light;
  // console.log(theme);

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.appLayout}>
        <Header setDarkMode={setDarkMode} />
        <Main children={children} />
        <Footer />
      </div>
    </ThemeProvider>
  );
};

export default Layout;
